import { render, staticRenderFns } from "./layout-box-simple.vue?vue&type=template&id=985609a2&functional=true"
import script from "./layout-box-simple.vue?vue&type=script&lang=js"
export * from "./layout-box-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('985609a2')) {
      api.createRecord('985609a2', component.options)
    } else {
      api.rerender('985609a2', component.options)
    }
    module.hot.accept("./layout-box-simple.vue?vue&type=template&id=985609a2&functional=true", function () {
      api.rerender('985609a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/layout/box/layout-box-simple.vue"
export default component.exports